































import {Component, Prop, Vue ,Watch} from "vue-property-decorator";
@Component({})
export default class ImageUpload extends Vue {
    @Prop({}) value!:any;
    @Prop({}) src!:string | null;
    @Prop({default:true}) required!:boolean;
    @Prop({}) label!:string;
    @Prop({}) propName!:string;
    @Prop({}) thumbPropName!:string;
    @Prop({default:""}) action!:string;

    @Watch('src')
    onPropertyChanged(value: string, oldValue: string) {
        const input : any = this.$refs.file;
        input.type = 'text'
        input.type = 'file'
        //clear selected file
    }
    serialize (obj:any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
              //@ts-ignore
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }
    async removeImage(){
        //var file = new File([],"empty.jpg",{type:"image/jpeg"});
        //this.$emit("input",file);
        var requestPayload:any = {};
        requestPayload[this.propName] = "";
        requestPayload[this.thumbPropName] = "";
        let response = await Vue.prototype.$http.request({
            method:"PATCH",
            url:this.action + "?" + this.serialize(requestPayload)
        });
        this.src = response.data[this.propName];
    }
    updateValue (e:any) {
        //console.log("input",e.target.files[0]);
        this.$emit('input', e.target.files[0])
        //TODO multiple olabilir .
    }
}
